module.exports = function () {

	$(document).on({
		click: function(e) {
			e.preventDefault();

			var link = $(this).data('href');
			if( link.indexOf('http') !== 0 ) {
				link = App.base + link;
			}

			window.location.assign(link);
		}
	}, '[data-href]');

}



// WEBPACK FOOTER //
// ./resources/assets/js/vn/data-href.js